<template>
  <div class="form-horizontal">
    <div class="header-t-text d-block">My Task List</div>
    <div class="d-block">
      <img
        class="dash-divider"
        src="img/line-divider-transparent-1_edited.png"
      />
    </div>
    <div class="form-group row mb-3">
      <div class="col-12 col-lg-8 col-xl-8">
        <table class="w-100">
          <tbody>
            <tr v-for="(item, index) in taskslist" :key="item.taskID">
              <td class="dash-task-col-title">
                {{ index + 1 }}) {{ setTitle(item.taskType, item) }}
              </td>
              <td class="dash-task-col-action">
                <button
                  class="mb-1 mt-1 mr-1 btn btn-sm btn-primary dash-task-btn"
                  @click="gotoTask(item)"
                >
                  {{ setButton(item.taskType, item) }}
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr v-if="taskslist.length === 0">
              <td colspan="2">
                <span>No tasks found.</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../api/http-common.js'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      taskslist: [],
      dt: []
    }
  },
  computed: {
    ...mapGetters(['getProfilePatientAssociated', 'currentPatientAssociated'])
  },
  methods: {
    ...mapActions([
      'setTaskCurrentTaskType',
      'setCurrentMsgInfo',
      'setMsgCurrentPage',
      'setTaskCode',
      'setBillingStatementTask',
      'setTaskInfo',
      'setTaskItem',
      'clearUrlLinkInfo'
    ]),
    setTitle(val, item) {
      switch (val) {
        case 'NPH':
        case 'AANPH':
        case 'CH':
        case 'AACH':
          return 'Health History'
        case 'MSG':
          return 'Message'
        case 'STMT':
          return 'Statement'
        case 'FORM':
          var info = JSON.parse(item.info)
          return info.Action
        case 'INS':
          return 'Insurance Information'
        case 'FV':
          return 'Documents Shared'
        default:
          return ''
      }
    },
    setButton(val, item) {
      switch (val) {
        case 'NPH':
        case 'AANPH':
        case 'CH':
        case 'AACH':
          return 'GO TO HEALTH HISTORY'
        case 'MSG':
          return 'GO TO MESSAGE'
        case 'STMT':
          return 'PAY STATEMENT'
        case 'FORM':
          var info = JSON.parse(item.info)
          return info.FormName.toUpperCase()
        case 'INS':
          var info2 = JSON.parse(item.info)
          return info2.Description.toUpperCase()
        case 'FV':
          return 'VIEW DOCUMENTS'
        default:
          return ''
      }
    },
    /** Health history task types that must be completed before form signing (NPH flow). */
    getHealthHistoryTaskTypes() {
      return ['NPH', 'AANPH', 'AACH', 'CH']
    },
    /** If there is an incomplete health history task in the list, return it; otherwise null. */
    getFirstIncompleteHealthHistoryTask() {
      const types = this.getHealthHistoryTaskTypes()
      return this.taskslist.find(
        (t) => t && t.taskID > 0 && types.includes(t.taskType)
      ) || null
    },
    async gotoTask(task) {
      let taskRes
      this.setTaskCode(task.taskType)
      switch (task.taskType) {
        case 'NPH':
        case 'AANPH':
        case 'INS':
        case 'AACH':
          await this.clearUrlLinkInfo()
          if (task.info !== '') {
            var taskinfo = JSON.parse(task.info)
            taskinfo.TaskType = task.taskType
            taskinfo.TaskID = task.taskID
            this.setTaskInfo(JSON.stringify(taskinfo))
          } else {
            this.setTaskInfo('')
          }
          this.setTaskCurrentTaskType('PatientInfo')
          await this.$router.push({ path: '/task' })
          break
        case 'CH':
          await this.clearUrlLinkInfo()
          this.setTaskInfo(task.info)
          this.setTaskItem(task)
          this.setTaskCurrentTaskType('PatientInfo')
          await this.$router.push({ path: '/task' })
          break
        case 'FORM': {
          // Ensure health history (NPH) is done first: if such a task exists, go to it instead of the form.
          const healthHistoryTask = this.getFirstIncompleteHealthHistoryTask()
          if (healthHistoryTask) {
            await this.gotoTask(healthHistoryTask)
            return
          }
          await this.clearUrlLinkInfo()
          var info = JSON.parse(task.info)
          // From Home/My Task List we should open forms in the same tab (no new window/tab).
          await this.$router.push({
            name: 'HandlerForm',
            query: {
              i: info.FacilityFormID,
              t: info.FormName,
              p: info.Data.PatientName,
              pid: task.patientID,
              tid: task.taskID
            }
          })
          break
        }
        case 'MSG':
          taskRes = await api.task.request.getSpecificTask(task.taskID)
          await api.task.request.updateTaskComplete({
            facilityId: this.currentPatientAssociated.facilityID,
            id: task.taskID,
            patientId: this.currentPatientAssociated.patientID
          })
          await this.clearUrlLinkInfo()
          this.setCurrentMsgInfo({
            id: parseInt(taskRes.data.info),
            subject: ''
          })
          this.setMsgCurrentPage('Detail')
          this.$router.push({ path: '/menu/messages' })
          break
        case 'STMT':
          taskRes = await api.task.request.getSpecificTask(task.taskID)
          this.setBillingStatementTask(taskRes.data)
          await this.clearUrlLinkInfo()
          this.$router.push({ path: '/menu/statement' })
          break
        case 'FV': {
          await this.clearUrlLinkInfo()
          // task.info is a JSON string, e.g.:
          // {"Action":"VIEWFILES","Description":"2539,2540","Instructions":"","Folder":""}
          let fvInfo = null
          try {
            fvInfo = task.info ? JSON.parse(task.info) : null
          } catch (e) {
            fvInfo = null
          }

          // Description can be a comma-delimited list of IDs
          const ids = (fvInfo && typeof fvInfo.Description === 'string'
            ? fvInfo.Description
            : ''
          )
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean)
            .map((s) => parseInt(s, 10))
            .filter((n) => Number.isFinite(n) && n > 0)
            .join(',')

          await api.task.request.updateTaskComplete({
            facilityId: this.currentPatientAssociated.facilityID,
            id: task.taskID,
            patientId: this.currentPatientAssociated.patientID
          })
          // Pass ids to Documents so it can filter to the shared files for this task
          this.$router.push({
            path: '/menu/documents',
            query: ids ? { ids } : {}
          })
          break
        }
        default:
          break
      }
    },
    date: function (date) {
      return moment(date).format('dddd  MM/DD/YYYY @ h:mm:ss a')
    },
    async loadTaskList() {
      if (this.currentPatientAssociated) {
        const res = await api.patient.request.gettasks({
          facilityId: this.currentPatientAssociated.facilityID,
          patientId: this.currentPatientAssociated.patientID
        })
        this.taskslist = res.data || []
        // From link (e.g. after attaching patient): "click" NPH so user goes to health history first.
        if (this.$route.query.fromLink && this.taskslist.length > 0) {
          const nphTask = this.getFirstIncompleteHealthHistoryTask()
          if (nphTask) {
            await this.$router.replace({ path: '/', query: {} })
            await this.gotoTask(nphTask)
          }
        }
      }
    }
  },
  async mounted() {
    console.log('dash-task loaded')
    this.loadTaskList()
  }
}
</script>
<style scoped>
.dash-divider {
  height: 4px;
  margin-bottom: 10px;
  width: 70%;
}

/* IPAD */
@media only screen and (max-width: 768px) {
  .dash-divider {
    width: 100%;
  }
}

/* ----------- iPhone 6, 7, 8 ----------- */
@media only screen and (max-device-width: 375px) and (orientation: portrait) {
  .dash-divider {
    width: 100%;
  }
}

@media only screen and (max-device-width: 667px) and (orientation: landscape) {
  .dash-divider {
    width: 100%;
  }
}

/* ----------- iPhone Plus ----------- */
@media only screen and (max-device-width: 414px) and (orientation: portrait) {
  .dash-divider {
    width: 100%;
  }
}

@media only screen and (device-width: 736px) and (orientation: landscape) {
  .dash-divider {
    width: 100%;
  }
}

/*IPHONE X */
@media only screen and (max-device-width: 375px) and (orientation: portrait) {
  .dash-divider {
    width: 100%;
  }
}

@media only screen and (device-width: 812px) and (orientation: landscape) {
  .dash-divider {
    width: 100%;
  }
}

/* ----------- iPhone 5, 5S, 5C and 5SE ----------- */
@media only screen and (max-device-width: 320px) and (orientation: portrait) {
  .dash-divider {
    width: 100%;
  }
}

@media only screen and (max-device-width: 568px) and (orientation: landscape) {
  .dash-divider {
    width: 100% !important;
  }
}
</style>
